var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnPost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_3392_54708)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51841 12.1005C5.49484 12.1124 5.49385 12.1343 5.51575 12.1489L7.52138 13.4739L8.09589 10.7703L5.51841 12.1005Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3935 10.7695H16.8863C16.8601 10.7695 16.8193 10.7795 16.7957 10.7914L14.2538 12.1011C14.2302 12.113 14.2292 12.1349 14.2511 12.1492L16.2232 13.4472C16.2454 13.4615 16.2846 13.4735 16.3112 13.4735H16.818C16.8442 13.4735 16.8478 13.4615 16.8263 13.4472L14.8133 12.1227L17.3984 10.7908C17.422 10.7795 17.4197 10.7695 17.3935 10.7695Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3077 10.7695H12.7744L12.2002 13.4741H15.7329C15.7591 13.4741 15.7627 13.4622 15.7408 13.4479L13.7312 12.1233L16.3127 10.7914C16.3362 10.7795 16.3339 10.7695 16.3077 10.7695Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4782 10.7695H17.971C17.9445 10.7695 17.904 10.7795 17.8804 10.7914L15.3385 12.1011C15.3152 12.113 15.3142 12.1349 15.3358 12.1492L17.3079 13.4472C17.3298 13.4615 17.3697 13.4735 17.3959 13.4735H17.903C17.9292 13.4735 17.9329 13.4615 17.911 13.4472L15.898 12.1227L18.4832 10.7908C18.5071 10.7795 18.5047 10.7695 18.4782 10.7695Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1505 9H7.83257C7.36825 9 7.04333 9.29207 6.96666 9.65317C6.92451 9.85131 6.99985 10.0275 7.15252 10.1483L10.1412 12.1215L10.1435 12.1205L10.1439 12.1215L16.1561 9.0219C16.1793 9.00996 16.177 9 16.1505 9Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8312 15.2171L10.1439 12.1216L10.1432 12.1226L10.1412 12.1216L6.3135 14.0953C6.10972 14.2155 5.9597 14.3921 5.91755 14.5905C5.84022 14.951 6.04068 15.2434 6.50533 15.2434H14.8232C14.8498 15.2437 14.8531 15.2318 14.8312 15.2171Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3392_54708",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E62926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69D28"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnPost);
export default __webpack_public_path__ + "static/media/unPost.bd2eb2567f283d28a0528d0281c0fed6.svg";
export { ForwardRef as ReactComponent };